import { SaveTemplatesTypes } from 'utils/types';
import * as yup from 'yup';

export const saveTeamplateValidationSchema = yup.object({
  isNew: yup.string().required('Field is required!'),

  name: yup
    .string()
    .when('isNew', {
      is: SaveTemplatesTypes.newTemplate,
      then: yup.string().required('Please fill new template title!').nullable(),
    })
    .nullable(),
});
